// import * as dotenv from "dotenv"
// dotenv.config()

// Identity Types
export const IDENTITY_TYPES = {
  HUMAN: 'human',
  NONHUMAN:"non-human",
};

// Risk Levels
export const RISK_LEVELS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical'
};

// Status
export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DISABLED: 'disabled'
};

// Display Labels
export const TYPE_LABELS = {
  [IDENTITY_TYPES.HUMAN]: 'Human',
  [IDENTITY_TYPES.NONHUMAN]: 'Non-Human',
};

export const RISK_LABELS = {
  [RISK_LEVELS.LOW]: 'Low',
  [RISK_LEVELS.MEDIUM]: 'Medium',
  [RISK_LEVELS.HIGH]: 'High',
  [RISK_LEVELS.CRITICAL]: 'Critical'
};

export const STATUS_LABELS = {
  [STATUS.ACTIVE]: 'Active',
  [STATUS.INACTIVE]: 'Inactive',
  [STATUS.DISABLED]: 'Disabled'
};

// Colors
export const TYPE_COLORS = {
  [IDENTITY_TYPES.HUMAN]: '#0078d4',
  [IDENTITY_TYPES.NONHUMAN]: '#ffc107',
  [IDENTITY_TYPES.APPLICATION]: '#28a745',
  [IDENTITY_TYPES.SERVICE_PRINCIPAL]: '#ffc107',
  [IDENTITY_TYPES.MANAGED_IDENTITY]: '#17a2b8',
  
};

export const RISK_COLORS = {
  [RISK_LEVELS.LOW]: '#28a745',
  [RISK_LEVELS.MEDIUM]: '#ffc107',
  [RISK_LEVELS.HIGH]: '#dc3545',
  [RISK_LEVELS.CRITICAL]: '#721c24'
};

export const STATUS_COLORS = {
  [STATUS.ACTIVE]: '#28a745',
  [STATUS.INACTIVE]: '#6c757d',
  [STATUS.DISABLED]: '#dc3545'
};

// Chart Colors
export const CHART_COLORS = {
  primary: ['#0078d4', '#28a745', '#ffc107', '#17a2b8', '#6f42c1', '#fd7e14'],
  risk: ['#28a745', '#ffc107', '#dc3545', '#721c24']
};

// Pagination
export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];

// APIs
// export const API_ISPM_BASE_URL = process.env.REACT_APP_API_URI_ISPM || 'http://localhost:5000/api/v1';
// export const API_ITDR_BASE_URL = process.env.REACT_APP_API_URI_ITDR || 'http://localhost:5000/itdr/api/';
// // export const API_BASE_URL = process.env.REACT_APP_API_URI_ITDR || 'http://localhost:5000/itdr/api/';
// export const ISPM_Rule_Engine_API_BASE_URL = process.env.REACT_APP_ISPM_RULE_ENGINE_URL


// export const API_ISPM_BASE_URL ='http://localhost:5000/api/v1';
// export const API_ITDR_BASE_URL = 'http://localhost:5000/api/v1/itdr';
// // export const API_BASE_URL = process.env.REACT_APP_API_URI_ITDR || 'http://localhost:5000/itdr/api/';
// export const ISPM_Rule_Engine_API_BASE_URL = 'http://localhost:80'


// // // --------------- Production -------------------
export const API_ISPM_BASE_URL = 'https://cirm.cf.deepalgorithms.net/api/v1';
export const API_ITDR_BASE_URL = 'https://cirm.cf.deepalgorithms.net/api/v1/itdr';
export const ISPM_Rule_Engine_API_BASE_URL = 'https://ispm2e6d.cf.deepalgorithms.net'

// --------------- Development --------------------
// export const API_ISPM_BASE_URL = 'https://dds.cf.adapid.link/api/v1';
// export const API_ITDR_BASE_URL = 'https://dds.cf.adapid.link/api/v1/itdr';
// export const ISPM_Rule_Engine_API_BASE_URL = 'https://nav.cf.adapid.link'

 
// src/utils/constants.js

export const OUTCOME_OPTIONS = [
  { value: "all", label: "All Outcomes" },
  { value: "success", label: "Success" },
  { value: "failed", label: "Failed" },
  { value: "blocked", label: "Blocked" },
  { value: "challenge", label: "Challenged" },
];

export const RISK_OPTIONS = [
  { value: "all", label: "All Risk Levels" },
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const IDENTITY_TYPE_OPTIONS = [
  { value: "all", label: "All Types" },
  { value: "human", label: "Human" },
  { value: "service", label: "Service" },
];

export const PAGE_SIZE = 20;